import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301). */
export const Route = createFileRoute("/jamfor-offert")({
  head: () => seoHead("/jamfor-offert"),
  beforeLoad: () => permanentRedirect("/offerter"),
});
